export default __webpack_public_path__ + "static/media/8.14ccd51f.png";